import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2 } from 'lucide-react';
const benefits = [{
  title: 'Professional Expertise',
  text: 'Founded by a licensed Estate Surveyor and Valuer, MUNISVERSE applies real estate knowledge to practical industry needs.'
}, {
  title: 'Technology with Purpose',
  text: 'We use immersive technology and visualisation to improve property presentation, inspection and documentation.'
}, {
  title: 'Beyond Visual Content',
  text: 'Our digital property experiences and visual records can be shared, accessed and revisited.'
}, {
  title: 'Built for Real Estate',
  text: 'Our services support the people and organisations that develop, value, market and manage property.'
}, {
  title: 'Beyond the Virtual Tour',
  text: 'We are building towards a broader digital infrastructure for how properties are experienced, presented and documented.'
}];
export function WhyMatters() {
  return <section className="py-24 bg-zinc-950" data-id="element-221" data-mp="h0sbrw2l3j1i">
      <div className="max-w-7xl mx-auto px-6" data-id="element-222" data-mp="h00jov8743fz">
        <div className="glass-panel rounded-3xl p-8 md:p-16 bg-gradient-to-br from-white/[0.05] to-transparent" data-id="element-223" data-mp="lriibcmqxrxs">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-224" data-mp="80doir627tvd">
            <FadeIn data-id="element-225" data-mp="c1p8ag295kvn">
              <h2 className="text-3xl md:text-4xl font-display font-medium text-white mb-6" data-id="element-226" data-mp="c17edq32biqw">
                Real Estate Expertise. Immersive Technology. A Broader Vision.
              </h2>
              <p className="text-zinc-400 text-lg leading-relaxed mb-8" data-id="element-227" data-mp="14q4k6tq37n2r">
                We are building a better digital layer around real estate.
              </p>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-228" data-mp="vpoklvcgt036">
              <ul className="space-y-6" data-id="element-229" data-mp="vowwt6p406ng">
                {benefits.map((benefit, index) => <li key={index} className="flex items-start gap-4" data-id="element-230" data-mp="3bgktd107nx5q" data-mpi={index}>
                    <CheckCircle2 className="w-6 h-6 text-white shrink-0" data-id="element-231" data-mp="3gfxhdp2tja9w" />
                    <span className="text-zinc-300 text-lg" data-id="element-232" data-mp="3gduiefjou6t1">
                      <span className="text-white font-medium" data-id="element-233" data-mp="1lynnm8czzeik">
                        {benefit.title}:
                      </span>{' '}
                      {benefit.text}
                    </span>
                  </li>)}
              </ul>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}